import { initStage } from "./stage.js";
import {
  initPerspectivesLinesBase,
  initPerspectivesVideoOnScroll,
} from "./perspectives.js";
import { initScrollReveal } from "./scroll-reveal.js";
import { initFiguresOdometer } from "./figures.js";
import { initPageHeader } from "./page-header.js";

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-stage]").forEach(initStage);
  document.querySelectorAll("[data-perspectives]").forEach((section) => {
    initPerspectivesLinesBase(section);
    initPerspectivesVideoOnScroll(section);
  });
  initScrollReveal();
  initFiguresOdometer();
  initPageHeader();
});
